// Desarrollo: .env.development | Producción (build): .env.production o REACT_APP_API_URL en CI
const raw = process.env.REACT_APP_API_URL || 'http://localhost:5296';

export const appConstants = {
  API_URL: raw.replace(/\/$/, ''),
};
